import { BsrsGrid, Column, AddressColumn } from '@/components/BsrsGrid'
import React from 'react'
import { useLocalization } from '@/hooks/localization'

const BlacklistReportGrid = ({ dataSource, sheetHeader }) => {
  const { localize } = useLocalization()

  return <BsrsGrid
    name='cbiIgnoredBlacklists' inputType='grid' readonly
    dataSource={dataSource} sheetHeader={sheetHeader} >
    <Column field='name' title={localize('Common.ArabicName')} />
    <Column field='latinName' title={localize('Common.LatinName')} />
    <Column field='code' title={localize('Common.Code')} />
    {AddressColumn({ dataField: 'address', locale: 'ar', field: 'address', title: localize('Common.ArabicAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'address', locale: 'en', field: 'latinAddress', title: localize('Common.EnglishAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'previousAddress', locale: 'ar', field: 'previousAddress', title: localize('Common.PreviousArabicAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'previousAddress', locale: 'en', field: 'previousLatinAddress', title: localize('Common.PreviousEnglishAddress'), filterable: false, editable: false })}
    <Column field='dayAdded' title={localize('Common.Day')} filterable={false} />
    <Column field='monthAdded' title={localize('Common.Month')} filterable={false} />
    <Column field='yearAdded' title={localize('Common.Year')} filterable={false} />
  </BsrsGrid>
}

export { BlacklistReportGrid }



// WEBPACK FOOTER //
// ./src/internal-app/pages/blacklistReports/blacklistReportGrid.js